export const atsLogoClasses = {
  root: 'atsLogo',
};
